import { useParams } from 'react-router-dom'

const useTokenId = (): number|null => {
  const { id } = useParams()
  if (id) return parseInt(id, 10)
  return null
}

export default useTokenId
